import { useNavigate } from "react-router-dom";
import {
  methodologyCards,
  theoryAlbumChapters,
  guides,
} from "./methodology-registry";
import { cn } from "@/lib/utils";

type Section = {
  title: string;
  eyebrow: string;
  pages: { path: string; label: string }[];
};

const sections: Section[] = [
  {
    title: "כרטיסיות השיטה",
    eyebrow: "עקרונות · תרגילים · מטאפורות",
    pages: methodologyCards,
  },
  {
    title: "אלבום התאוריה",
    eyebrow: "פרקים מתוך אלבום התאוריה המונטסורי",
    pages: theoryAlbumChapters,
  },
  {
    title: "מדריכים ותבניות",
    eyebrow: "תבניות מפגש · הרהורים · תסריטים",
    pages: guides,
  },
];

export function MethodologyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-svh -mx-6 -my-8 px-6 py-6 sm:py-8 bg-stone-50">
      <div className="mx-auto max-w-5xl">
        <header className="mb-8">
          <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-stone-500">
            ספרייה
          </p>
          <h1 className="mt-2 text-3xl sm:text-4xl font-bold tracking-[-0.02em] leading-tight text-stone-900">
            מתודולוגיה.
          </h1>
          <p className="mt-3 text-base text-stone-600 max-w-xl leading-relaxed">
            כרטיסיות השיטה, פרקי התאוריה, ומדריכים מעשיים — כולם במקום אחד.
          </p>
        </header>

        <div className="space-y-12">
          {sections.map((section) => (
            <section key={section.title}>
              <div className="mb-5 flex items-baseline justify-between gap-4">
                <div>
                  <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-stone-500">
                    {section.eyebrow}
                  </p>
                  <h2 className="mt-2 text-2xl sm:text-3xl font-bold tracking-tight text-stone-900">
                    {section.title}
                  </h2>
                </div>
                <span className="text-3xl font-bold tabular-nums text-stone-900">
                  {section.pages.length}
                </span>
              </div>

              {section.pages.length === 0 ? (
                <p className="text-sm text-stone-500">
                  עוד לא נטען תוכן בקטגוריה הזו.
                </p>
              ) : (
                <div className="rounded-[24px] bg-white overflow-hidden">
                  <table className="w-full text-sm">
                    <tbody>
                      {section.pages.map((p, idx) => (
                        <tr
                          key={p.path}
                          onClick={() => navigate(p.path)}
                          className={cn(
                            "border-t first:border-t-0 border-stone-200/70 cursor-pointer",
                            "hover:bg-stone-50 transition-colors",
                          )}
                        >
                          <td className="px-6 py-4 align-middle font-bold tabular-nums text-stone-900 w-16">
                            {String(idx + 1).padStart(2, "0")}
                          </td>
                          <td className="px-6 py-4 align-middle">
                            <span className="text-base font-semibold text-stone-900 tracking-tight">
                              {p.label}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
